<script setup>
import { ref } from 'vue';
import { router, Head, Link } from '@inertiajs/vue3';

const props = defineProps({
    currentLocale: String,
    fallbackLocale: String
});

// Set variables for programme and organisation objects
const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
// Check if custom names have been set for team/organisation and assign data to variables as required
const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;
const team_name = (programme.organisation_custom_name && programme.team_custom_name.length == 0) ? programme.team_custom_name : 'Team' ;

const convertToObject = (json) => {
    if (json.constructor.name != 'Object') {
        json = JSON.parse(json)
    }
    return json;
}


const default_text = router.page.props.ziggy.default_text;
let dashboard_text = null;
let organisationDashboardText = null;
let programmeDashboardText = null;

if (organisation && organisation.dashboard_text) {
    organisation.dashboard_text = convertToObject(organisation.dashboard_text);
    organisationDashboardText = Object.values(organisation.dashboard_text).every((x) => x === null);
}

if (programme.dashboard_text) {
    programme.dashboard_text = convertToObject(programme.dashboard_text);
    programmeDashboardText = Object.values(programme.dashboard_text).every((x) => x === null);
}

if (organisation && !organisationDashboardText) { //if all object keys are not null
    dashboard_text = organisation.dashboard_text;
} else if (!programmeDashboardText) { //if all object keys are not null
    dashboard_text = programme.dashboard_text;
} else if (default_text){
    dashboard_text = default_text.filter((item) => {
        return item.key == "dashboard";
    });
    dashboard_text = dashboard_text[0].content;

    if (dashboard_text) {
        dashboard_text = convertToObject(dashboard_text);
    }
}

</script>

<template>
        <div class="dashboard-widget welcome-widget p-6 sm:px-20 bg-white border-b border-gray-200 rounded-2xl mb-5">

            <div class="mt-6 text-gray-500">

                <h2>{{$t('dashboard.greeting', { name: $page.props.auth.user.first_name })}}</h2>

                <!-- <p>If the naming conventions for 'team' and 'organisation' in your programme have been
                    customised, you will see them differently below:
                </p>

                <ul>
                    <li>Team is referred to as <em>{{ team_name }}</em></li>
                    <li>Organisation is referred to as <em>{{ organisation_name }}</em></li>
                </ul> -->

                <h3>{{$t('dashboard.intro_text')}}</h3>
                <div v-if="dashboard_text && (dashboard_text[$i18n.locale] || dashboard_text[$i18n.fallbackLocale])" v-html="dashboard_text[$i18n.locale] ? dashboard_text[$i18n.locale] : dashboard_text[$i18n.fallbackLocale]"></div>
            </div>

        </div>
</template>
